import { styled } from '@mui/material'
import DateLinearProgress from '@src/components/share/generic/DateLinearProgress'
import React from 'react'

const Title = styled('div')`
  font-size: 16px;
  line-height: 18px;
  color: #c4c4c4;
  margin-bottom: 16px;
`

export const CooldownProgress: React.FC<CooldownProgressProps> = props => {
  const { className, startAt, endAt, now, title } = props

  return (
    <div className={className}>
      <Title>{title}</Title>
      <DateLinearProgress startAt={startAt} endAt={endAt} now={now} />
    </div>
  )
}

export type CooldownProgressProps = {
  className?: string
  title?: string
  startAt: Date
  endAt: Date
  now: Date
}
